import React, { FC, ReactElement } from 'react';
import Table from 'react-bootstrap/Table';
import i18next from 'i18next';
import { Badge, Button } from 'react-bootstrap';
import { PromQuestionDto, PromQuestionLocalizedContentDto } from '../../../../shared/dtos/prom.dto';
import { getPromQuestionLocalizedContent } from '../../util/prom-utils';

type PromQuestionTableProps = {
  promQuestions: PromQuestionDto[];
  onClick?: (promQuestion: PromQuestionDto) => void;
}

const PromQuestionTable: FC<PromQuestionTableProps> = ({ promQuestions, onClick }: PromQuestionTableProps): ReactElement => {

  return (
    <Table striped bordered hover responsive className="h-75 overflow-auto">
      <thead>
        <tr>
          <th className="centered-td">{i18next.t('promQuestion.title')}</th>
          <th className="centered-td">{i18next.t('promQuestion.questionText')}</th>
          <th className="centered-td">{i18next.t('promQuestion.questionType')}</th>
          <th className="centered-td">{i18next.t('promQuestion.trigger')}</th>
          <th className="centered-td">{i18next.t('promQuestion.metric')}</th>
          <th className="centered-td">{i18next.t('promQuestion.isActive')}</th>
          {onClick && (<th></th>)}
        </tr>
      </thead>
      <tbody>
        {promQuestions.map((promQuestion: PromQuestionDto) => {
          const content: PromQuestionLocalizedContentDto | null = getPromQuestionLocalizedContent(
            promQuestion,
            i18next.language,
          );

          return (
            <tr key={promQuestion.id}>
              <td className="centered-td">{content?.title ?? '-'}</td>
              <td className="centered-td">{content?.questionText ?? '-'}</td>
              <td className="centered-td">{i18next.t(`promQuestion.questionTypes.${promQuestion.questionType}`)}</td>
              <td className="centered-td">{i18next.t(`promQuestionnaireDetails.trigger.${promQuestion.trigger}`)}</td>
              <td className="centered-td">
                {promQuestion.metric ? i18next.t(`enduranceTrainingType.promMetric.${promQuestion.metric}`) : '-'}
              </td>
              <td className="centered-td">
                <Badge className={promQuestion.isActive ? 'badge-bg-info' : 'badge-bg-danger'}>
                  {i18next.t(promQuestion.isActive ? 'promQuestion.active' : 'promQuestion.inactive')}
                </Badge>
              </td>
              {onClick && (
                <td className="centered-td">
                  <Button variant="dark" onClick={() => { onClick(promQuestion); }}>
                    {i18next.t('generic.edit')}
                  </Button>
                </td>
              )}
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};

export default PromQuestionTable;
